/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Birthday_Event_Ended_Boxes_Waiting_TitleInputs */

const en_birthday_event_ended_boxes_waiting_title = /** @type {(inputs: Birthday_Event_Ended_Boxes_Waiting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your cake boxes are waiting!`)
};

const ar_birthday_event_ended_boxes_waiting_title = /** @type {(inputs: Birthday_Event_Ended_Boxes_Waiting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صناديق الكيك الخاصة بك في انتظارك!`)
};

const de_birthday_event_ended_boxes_waiting_title = /** @type {(inputs: Birthday_Event_Ended_Boxes_Waiting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Kuchenboxen warten auf dich!`)
};

const es_birthday_event_ended_boxes_waiting_title = /** @type {(inputs: Birthday_Event_Ended_Boxes_Waiting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Tus cajas de pasteles te esperan!`)
};

const fr_birthday_event_ended_boxes_waiting_title = /** @type {(inputs: Birthday_Event_Ended_Boxes_Waiting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vos boîtes à gâteaux vous attendent !`)
};

const it_birthday_event_ended_boxes_waiting_title = /** @type {(inputs: Birthday_Event_Ended_Boxes_Waiting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le tue scatole di torte ti aspettano!`)
};

const ja_birthday_event_ended_boxes_waiting_title = /** @type {(inputs: Birthday_Event_Ended_Boxes_Waiting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ケーキボックスが待っています！`)
};

const ko_birthday_event_ended_boxes_waiting_title = /** @type {(inputs: Birthday_Event_Ended_Boxes_Waiting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`케이크 상자가 기다리고 있어요!`)
};

const pt_br_birthday_event_ended_boxes_waiting_title = /** @type {(inputs: Birthday_Event_Ended_Boxes_Waiting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suas caixas de bolo estão esperando!`)
};

const ru_birthday_event_ended_boxes_waiting_title = /** @type {(inputs: Birthday_Event_Ended_Boxes_Waiting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваши коробочки с тортами ждут вас!`)
};

const th_birthday_event_ended_boxes_waiting_title = /** @type {(inputs: Birthday_Event_Ended_Boxes_Waiting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กล่องเค้กของคุณรอคุณอยู่!`)
};

const tr_birthday_event_ended_boxes_waiting_title = /** @type {(inputs: Birthday_Event_Ended_Boxes_Waiting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasta kutuların seni bekliyor!`)
};

const zh_cn_birthday_event_ended_boxes_waiting_title = /** @type {(inputs: Birthday_Event_Ended_Boxes_Waiting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`别忘了领取你的蛋糕礼盒！`)
};

const zh_tw_birthday_event_ended_boxes_waiting_title = /** @type {(inputs: Birthday_Event_Ended_Boxes_Waiting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`別忘了領取你的蛋糕禮盒！`)
};

/**
* | output |
* | --- |
* | "Your cake boxes are waiting!" |
*
* @param {Birthday_Event_Ended_Boxes_Waiting_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const birthday_event_ended_boxes_waiting_title = /** @type {((inputs?: Birthday_Event_Ended_Boxes_Waiting_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Birthday_Event_Ended_Boxes_Waiting_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_birthday_event_ended_boxes_waiting_title(inputs)
	if (locale === "ar") return ar_birthday_event_ended_boxes_waiting_title(inputs)
	if (locale === "de") return de_birthday_event_ended_boxes_waiting_title(inputs)
	if (locale === "es") return es_birthday_event_ended_boxes_waiting_title(inputs)
	if (locale === "fr") return fr_birthday_event_ended_boxes_waiting_title(inputs)
	if (locale === "it") return it_birthday_event_ended_boxes_waiting_title(inputs)
	if (locale === "ja") return ja_birthday_event_ended_boxes_waiting_title(inputs)
	if (locale === "ko") return ko_birthday_event_ended_boxes_waiting_title(inputs)
	if (locale === "pt_br") return pt_br_birthday_event_ended_boxes_waiting_title(inputs)
	if (locale === "ru") return ru_birthday_event_ended_boxes_waiting_title(inputs)
	if (locale === "th") return th_birthday_event_ended_boxes_waiting_title(inputs)
	if (locale === "tr") return tr_birthday_event_ended_boxes_waiting_title(inputs)
	if (locale === "zh_cn") return zh_cn_birthday_event_ended_boxes_waiting_title(inputs)
	return zh_tw_birthday_event_ended_boxes_waiting_title(inputs)
});